import { useEffect } from 'react'
import {setTitle} from './postMessage'

export default function useTitle(title: string) {
    useEffect(() => {
        document.title = title
        setTitle(title)
    }, [title])
}